import { useTranslation } from 'react-i18next';
import { QRadio, QRadioGroup, QStack } from '@qualio/ui-components';
import { StandardValueObject, SubComponentProps, ViewModeDictionary } from '../EventFormField.types';
import { createFieldValueArray } from '../../../utils/eventFormUtils';
import { ConvertBooleanStringToYesOrNo, EnsureBooleanString } from '../../../utils/booleanUtils';
import ReadonlyWrapper from './ReadOnlyWrapper';
import TextOr from '../../TextOr/TextOr';

const BooleanField = (props: SubComponentProps) => {
  const { t } = useTranslation();
  const { fieldValues, onChange, fieldId, mode } = props;

  // TODO:  QEV-2813
  const valueObj = fieldValues[0] as StandardValueObject | undefined;

  if (mode === ViewModeDictionary.READONLY) {
    return (
      <ReadonlyWrapper>
        <TextOr fontSize="sm" value={valueObj?.value} transform={ConvertBooleanStringToYesOrNo} />
      </ReadonlyWrapper>
    );
  }

  return (
    <QRadioGroup
      data-cy={'boolean-select'}
      onChange={(value) => {
        const newValueArray = createFieldValueArray(value, fieldId, valueObj, EnsureBooleanString);

        onChange(newValueArray);
      }}
      value={valueObj?.value}
    >
      <QStack direction="column">
        <QRadio data-cy={'boolean-select-true'} value="true">
          {t('common.labels.yes')}
        </QRadio>
        <QRadio data-cy={'boolean-select-false'} value="false">
          {t('common.labels.no')}
        </QRadio>
      </QStack>
    </QRadioGroup>
  );
};

export default BooleanField;
